import React from "react";

const GradientColors = ({ qrOptions, handleGradientColorChange, gradientType, handleGradientTypeChange }) => {
    return (
        <>
            <div className="form-group">
                <label htmlFor="qr-gradient-color1">Cor Gradiente 1</label>
                <input type="color" id="qr-gradient-color1" value={qrOptions.gradientColors ? qrOptions.gradientColors[0] : "#000000"} onChange={(e) => handleGradientColorChange(e, 0)} />
                <input type="text" value={qrOptions.gradientColors ? qrOptions.gradientColors[0] : "#000000"} onChange={(e) => handleGradientColorChange(e, 0)} />
            </div>
            <div className="form-group">
                <label htmlFor="qr-gradient-color2">Cor Gradiente 2</label>
                <input type="color" id="qr-gradient-color2" value={qrOptions.gradientColors ? qrOptions.gradientColors[1] : "#1845af"} onChange={(e) => handleGradientColorChange(e, 1)} />
                <input type="text" value={qrOptions.gradientColors ? qrOptions.gradientColors[1] : "#1845af"} onChange={(e) => handleGradientColorChange(e, 1)} />
            </div>
            <div className="form-group">
                <label htmlFor="qr-gradient-type">Tipo de Gradiente</label>
                <select id="qr-gradient-type" value={gradientType} onChange={(e) => handleGradientTypeChange(e.target.value)}>
                    <option value="linear">Linear Gradiente</option>
                    <option value="radial">Radial Gradiente</option>
                </select>
            </div>
        </>
    );
};

export default GradientColors;